export default "__VITE_ASSET__DejOPuja__"